import { ModelFactory } from "../../../ModelFactory";

export class SiteInfo {
  constructor(
    public readonly sitesDir: string,
  ) {
  }
}

class SiteInfoFactory extends ModelFactory<SiteInfo> {
  protected fromJson(json: any): SiteInfo {
    return new SiteInfo(
      json['sites_dir'],
    );
  }
}
export const siteInfoFactory = new SiteInfoFactory();
